/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Carry_SaveInputs */

const en_us2_workout_after_carry_save = /** @type {(inputs: Workout_After_Carry_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update my plan`)
};

const pt_br2_workout_after_carry_save = /** @type {(inputs: Workout_After_Carry_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar o plano`)
};

const es_419_workout_after_carry_save = /** @type {(inputs: Workout_After_Carry_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar mi plan`)
};

const pt_pt2_workout_after_carry_save = /** @type {(inputs: Workout_After_Carry_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar o plano`)
};

const fr_fr2_workout_after_carry_save = /** @type {(inputs: Workout_After_Carry_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à jour`)
};

const de_de2_workout_after_carry_save = /** @type {(inputs: Workout_After_Carry_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan aktualisieren`)
};

const it_it2_workout_after_carry_save = /** @type {(inputs: Workout_After_Carry_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna la scheda`)
};

/**
* | output |
* | --- |
* | "Update my plan" |
*
* @param {Workout_After_Carry_SaveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_carry_save = /** @type {((inputs?: Workout_After_Carry_SaveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Carry_SaveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_carry_save(inputs)
	if (locale === "es-419") return es_419_workout_after_carry_save(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_carry_save(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_carry_save(inputs)
	if (locale === "de-DE") return de_de2_workout_after_carry_save(inputs)
	if (locale === "it-IT") return it_it2_workout_after_carry_save(inputs)
	return en_us2_workout_after_carry_save(inputs)
});
export { workout_after_carry_save as "workout-after.carry_save" }